import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  { q: 'Tente sistemleri rüzgara dayanıklı mı?', a: 'Evet, tüm tente sistemlerimiz belirli rüzgar hızlarına dayanacak şekilde tasarlanmıştır. Win tente modelimiz özellikle Ege\'nin kuvvetli rüzgarlarına karşı güçlendirilmiş kol yapısıyla öne çıkar. Motorlu modellerde isteğe bağlı rüzgar sensörü eklenebilir.' },
  { q: 'Pergola sistemleri dört mevsim kullanılır mı?', a: 'Bioklimatik ve otomatik pergola sistemlerimiz dört mevsim kullanıma uygundur. Döner lamelli bioklimatik pergolalar yağmur geçirmez tavan oluşturur; isteğe bağlı ısıtıcı ve LED aydınlatma eklenerek kış aylarında da konforlu kullanım sağlanır.' },
  { q: 'Zip perde ne işe yarar?', a: 'Zip perde, fermuar sistemiyle kılavuz raylara kilitlenebilen, rüzgara karşı sızdırmaz bir dış mekân perde çözümüdür. Standart perdelerden farklı olarak rüzgarda savrulmaz; kenarları tamamen kapalı kalır. Teras, balkon ve kafe alanlarını neredeyse kapalı alan konforuna taşır.' },
  { q: 'Şeffaf branda yağmur geçirir mi?', a: 'Hayır, yüksek kaliteli PVC malzemeden üretilen şeffaf brandalarımız yağmur geçirmez. Doğru montaj yapıldığında su sızdırmazlık tam anlamıyla sağlanır. Şeffaf yapısı sayesinde manzara ve doğal ışık kesilmez.' },
  { q: 'Montaj ne kadar sürer?', a: 'Standart bir tente uygulaması genellikle yarım gün ile bir gün arasında tamamlanır. Pergola sistemleri ise 1-3 gün sürebilir. Keşif aşamasında uzman ekibimiz size kesin süre bilgisi verir.' },
  { q: 'İzmir\'in hangi ilçelerine hizmet veriyorsunuz?', a: 'İzmir\'in tüm ilçelerine hizmet veriyoruz. Karşıyaka, Bornova, Buca, Gaziemir, Balçova, Narlıdere, Çiğli, Bayraklı, Konak ve Menemen başta olmak üzere İzmir genelinde ücretsiz keşif yapıyoruz.' },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#0f1923] py-20 md:py-28" id="sss">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14">

          {/* Left */}
          <div className="lg:col-span-2">
            <p className="font-body text-[#d4a853] text-xs font-semibold tracking-[0.25em] uppercase mb-5">— Merak Edilenler</p>
            <h2 className="font-heading text-4xl md:text-5xl text-white leading-tight mb-6">
              Sık Sorulan <br />
              <span className="text-[#d4a853] italic">Sorular</span>
            </h2>
            <p className="font-body text-white/45 text-sm leading-relaxed mb-8">
              Tente, pergola ve branda sistemleri hakkında en çok sorulan soruların yanıtları burada.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="tel:05362771709"
                className="inline-flex items-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold text-sm px-6 py-3 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>Hemen Ara
              </a>
              <Link
                to="/sss"
                className="inline-flex items-center gap-2 border border-white/15 text-white/60 font-body font-medium text-sm px-6 py-3 rounded-lg hover:border-[#d4a853] hover:text-[#d4a853] transition-all cursor-pointer whitespace-nowrap"
              >
                Tüm Sorular <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Right */}
          <div className="lg:col-span-3 flex flex-col gap-2">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`border rounded-xl overflow-hidden transition-all duration-300 ${open === i ? 'border-[#d4a853]/40 bg-white/5' : 'border-white/8 bg-white/3'}`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <h3 className={`font-body font-semibold text-sm leading-snug ${open === i ? 'text-[#d4a853]' : 'text-white/80'}`}>
                    {faq.q}
                  </h3>
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors ${open === i ? 'bg-[#d4a853] text-[#0f1923]' : 'bg-white/8 text-white/50'}`}>
                    <i className={`text-sm ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {open === i && (
                  <div className="px-5 pb-5">
                    <p className="font-body text-white/50 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
